<template>
    <div class="flex-group" style="border-bottom: 1px solid grey;padding: 10px;font-size: 14px;">
      <div class="item" style="flex: 1; margin-right: 20px;text-align: left;">
        <p class="txt-bold">
          金额：{{ SafeItem.bet_amount
          }}<span style="float: right; color: #999">{{
            SafeItem.bet_time
          }}</span>
        </p>
        <p class="payType">
          {{ SafeItem.Code
          }}<span style="float: right; color: #999"
            >派彩：{{ SafeItem.win_loss }}</span
          >
        </p>
        <p>订单号：{{ SafeItem.bet_id }}</p>
      </div>
      <div class="item">
        <p class="status">{{ statuType[SafeItem.state] }}</p>
      </div>
    </div>
</template>

<script>
export default {
  name: 'BetItemView',
  props: ['item'],
  computed: {
    SafeItem () {
      return this.item || {}
    }
  },
  data(){
    return {
        stateType12: ['待支付', '成功', '失败', '超时'],
      stateType22: ['','待审核','通过','拒绝'],
      statuType: ['无效注单', '已结算', '未结算'],
      stateType34: ['失败', '成功', '待结算', '未定义'],
    }
  }
}
</script>

<style></style>
